import axios from 'axios';

axios.defaults.withCredentials = true;

export async function getPoblaciones() {
  try {
    const response = await axios.get(`${import.meta.env.VITE_APP_API_URL}get-poblaciones`);
    return response.data

  } catch (error) {
    console.error('Error al obtener las poblaciones', error);
  }
}